module.exports = __webpack_public_path__ + "static/img/点击用券@3x.88e59a65.png";